export enum TwoFactorStatusEnum {
  ACTIVE = 'active',
  INITIAL = 'initial',
  INACTIVE = 'inactive',
  ERROR = 'error',
}
